export default "assets/images/icons/cart-a55fbb61.svg";